import styled from '@xstyled/styled-components';
import { FlexBox } from '@/UI/Primitives/FlexBox';

export const CatalogueContainer = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 224px;

  .filter {
    display: inline-flex;
    align-items: center;

    svg {
      transform: scale(1.5);
    }
  }

  @media (max-width: desktop) {
    padding: 0 1rem;

    h3 span {
      display: none;
    }
  }

  @media (min-width: desktop) {
    flex-direction: row;
  }
`;

export const ResultsContainer = styled(FlexBox)`
  flex-direction: column;
  margin-top: 1rem;

  @media (min-width: desktop) {
    width: 72%;
    margin-top: 3rem;
  }
`;
